<template>
<div>
  <div style="width: 700px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div slot="header" class="clearfix">
            <span>报价器-荒野乱斗</span>
          </div>
          <el-tabs v-model="activeType" type="card">
            <el-tab-pane label="等级" name="level">
              <level ref="fromLevel"></level>
            </el-tab-pane>
            <el-tab-pane label="奖杯" name="cup">
              <cup ref="fromCup"></cup>
            </el-tab-pane>
          </el-tabs>
          <div>
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="genPrice" style="margin-left: 5px" class="btnGen" id="btnGen"
                             ref="btnGen" >生成报价
                  </el-button>
                  <el-button id="btnCopy" v-clipboard:copy="content" v-clipboard:success="onCopy"
                             v-clipboard:error="onError" ref="btnCopy" >复制报价
                  </el-button>
                  <el-button @click="reset" id="btnReset">重置查询</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content"
                          :autosize="{ minRows: 3, maxRows: 10}"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div></div>
    <keywords :do-copy="doCopy" :gen-price="genPrice" :reset="reset"></keywords>
  </div>
</div>
</template>

<script>
  import Level from '../components/Level'
  import Cup from '../components/Cup'
  import keywords from '../components/keywords/keywords'
  export default {
    name: 'BS',
    components:{Level,Cup,keywords},
    data(){
      return{
        gameId:51,
        activeType:'level',
        content: '',
        /*1 等级 ,2 奖杯*/
        type: 1

      }
    },
    mounted () {
      //this.enterKeyup();
    },
    methods:{
      genPrice (event) {
        let that = this
        if (that.activeType === 'level') {
          that.type=1
          that.levelDanPrice()
        } else if (that.activeType === 'cup') {
          that.type=2
          that.cupDanPrice()
        }
      },
      levelDanPrice(){
        let that = this
        let from = that.$refs['fromLevel'].fromLevel
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          type:that.type
        }
        this.$http.post('/api/bs/price/dan', data).then((res) => {
          if (res == null) {
            return
          }
          that.content = res.data
          that.doCopy(this.content)
          that.$message('等级报价生成成功！')
        })
      },
      cupDanPrice(){
        let that = this
        let from = that.$refs['fromCup'].fromCup
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          type:that.type
        }
        this.$http.post('/api/bs/price/dan', data).then((res) => {
          if (res == null) {
            return
          }
          that.content = res.data
          that.doCopy(this.content)
          that.$message('奖杯报价生成成功！')
        })
      },
      doCopy (e) {
        let that = this
        that.$copyText(this.content).then(function (e) {
          that.$message('内容已复制到剪切板')

        }, function (e) {
          if (that.prompt) {
            that.prompt = false
            that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！')
          }

        })
      },
      onCopy (e) {
        this.$message('内容已复制到剪切板！')
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message('抱歉，您的浏览器不支持！')
      },
      reset (){
        let that=this
        if(that.activeType === 'level'){
          that.type=1
          that.$refs['fromLevel'].fromLevel.fromPoint = ''
          that.$refs['fromLevel'].fromLevel.showTime = true
          that.$refs['fromLevel'].fromLevel.toPoint = ''
        }else {
          that.type=2
          that.$refs['fromCup'].fromCup.fromPoint = ''
          that.$refs['fromCup'].fromCup.showTime = true
          that.$refs['fromCup'].fromCup.toPoint = ''
        }
        this.content=''
        this.$message('重置成功')
      },
      enterKeyupDestroyed() {
        document.removeEventListener("keyup", this.enterKey);
      },
      enterKeyup() {
        document.addEventListener("keyup", this.enterKey);
      },
      enterKey(event) {
        const componentName = this.$options.name;

        if (componentName == "BS") {
          const code = event.keyCode
            ? event.keyCode
            : event.which
              ? event.which
              : event.charCode;

          if (code == 32) {
            this.genPrice();
          }else if(code == 13){
            this.doCopy()
          }else if(code ==192){
            this.reset()
          }
        }
      },
      showMessage(msg,duration){
        let that=this
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration
        });
      },
    },
    destroyed(){
      let that=this
      that.$message.closeAll()
      // 销毁enter事件
      this.enterKeyupDestroyed();
    },
    beforeDestroy(){
      // 销毁enter事件
      this.enterKeyupDestroyed()
    },


  }
</script>

<style scoped>

</style>
